import imgKanade101 from "./img-kanade10 (1).webp";
import imgKanade102 from "./img-kanade10 (2).webp";

const imgKanade10 = [imgKanade101, imgKanade102];

export default imgKanade10;
